import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Center,
  DrawerFooter,
  Spinner,
  useMediaQuery,
  useToast,
} from "@chakra-ui/react";
import { isEmpty, omit, set } from "lodash";
import { useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import DrawerWrapper from "../../../drawers/DrawerWrapper";
import { CREATE_USER } from "./mutations";
import { GET_USER_ADDRESS } from "./queries";
import UserMassCreateForm from "./UserMassCreateForm";

type UserMassCreateProps = {
  onOpen: () => void;
  onClose: () => void;
  isOpen: boolean;
  refetch?: any;
};

const UserMassCreate = (props: UserMassCreateProps) => {
  const { auth } = useContext(AuthContext);
  const isAdmin = auth.role === "ADMIN";
  const { isOpen, onClose, refetch } = props;
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  const toast = useToast();
  // const { data: userAddress, loading: userAddressLoading } = useQuery(
  //   GET_USER_ADDRESS,
  //   {
  //     variables: { id: auth.id },
  //   }
  // );
  const [createUser, { loading }] = useMutation(CREATE_USER);
  const onSubmit = ({ users }: any) => {
    let inputs = [];

    for (const user of users) {
      if (!isAdmin) {
        set(user, "role", "INDIVIDUAL");
      }

      inputs.push({
        ...user,
      });
    }

    return createUser({
      variables: {
        inputs,
      },
    })
      .then((data: any) => {
        if (data) {
          onClose();
          refetch && refetch();
          if (!toast.isActive("active-toast")) {
            toast({
              id: "active-toast",
              title: "Succesfully created",
              description: `${data?.data.userCreate.length} was created`,
              status: "success",
              duration: 3000,
              isClosable: true,
              variant: "solid",
            });
          }
        }
      })
      .catch((error) => {
        if (!toast.isActive("active-toast")) {
          toast({
            id: "active-toast",
            title: error.message,
            description: "Please, try again.",
            status: "error",
            duration: 2000,
            isClosable: true,
            variant: "solid",
          });
        }
      });
  };

  const formName = "createMassUserForm";

  return (
    <DrawerWrapper
      onClose={onClose}
      isOpen={isOpen}
      title="Users | Create"
      size="md"
      placement={isAdmin ? "bottom" : "right"}
    >
      {loading ? (
        <Center py="5">
          <Spinner />
        </Center>
      ) : (
        <UserMassCreateForm
          onSubmit={onSubmit}
          formName={formName}
          isAdmin={isAdmin}
          initialValues={{
            users: [{}],
          }}
        />
      )}

      <DrawerFooter>
        <Button mr="3" w={isLargerThan900 ? "50" : "full"} onClick={onClose}>
          Cancel
        </Button>
        <Button
          w={isLargerThan900 ? "50" : "full"}
          form={formName}
          colorScheme="whatsapp"
          type="submit"
          isLoading={loading}
          isDisabled={loading}
        >
          Create
        </Button>
      </DrawerFooter>
    </DrawerWrapper>
  );
};

export default UserMassCreate;
